import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareBehindSquare1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconSquareBehindSquare1"><Path fillRule="evenodd" clipRule="evenodd" d="M2 4C2 2.89543 2.89543 2 4 2H14C15.1046 2 16 2.89543 16 4V8H20C21.1046 8 22 8.89543 22 10V20C22 21.1046 21.1046 22 20 22H10C8.89543 22 8 21.1046 8 20V16H4C2.89543 16 2 15.1046 2 14V4ZM14.5 8H10C8.89543 8 8 8.89543 8 10V14.5H4C3.72386 14.5 3.5 14.2761 3.5 14V4C3.5 3.72386 3.72386 3.5 4 3.5H14C14.2761 3.5 14.5 3.72386 14.5 4V8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSquareBehindSquare1;
